export enum Screen {
  TOPHEADER = 'TOP_HEADER',
  ADMIN = 'ADMIN',
  USERPROFILE = 'USER_PROFILE',
}
